// 旧官网部署在 /act 子路径下，统一取自 vue.config.js 的 publicPath。
// Vue CLI 会把 publicPath 注入为 process.env.BASE_URL（形如 "/act/"）。
// 以后调整部署路径时，只需改 vue.config.js 的 publicPath 一处即可。
export const basePath = process.env.BASE_URL;

const proto = "https";
const domain = `www.mahjong-jp.com${basePath}drtest`;
const pureUrl = `${proto}://${domain}`;
export const shareConfig = {
  url: encodeURIComponent(pureUrl),
  domain: domain,
  pureUrl: pureUrl,
  url_cn: encodeURIComponent(`https://www.lizhimahjong.com${basePath}drtest`),
  title: "survey_bg.p28",
  text_1: "survey_bg.p36",
  text_2: "survey_bg.p37",
  tag_1: "survey_bg.p46",
  tag_2: "survey_bg.p47",
  // via: "", // Twitter account 未使用该参数
};
